import { t } from "i18next";
import * as Yup from "yup";

export const initialValues = {
  typeOfSlip: null,
  paySlipSize: null,
};

export const CompanySignatureSchema = Yup.object().shape({
  authorized: Yup.string().required("Please select."),
  signature: Yup.string().required(t("message.pleaseUploadAtLeastOneFile")),
});

const CompanyDocumentSchema = Yup.object().shape({
  typeOfSlip: Yup.string().required("Please select."),
  paySlipSize: Yup.string().required("Please select."),
});

export default CompanyDocumentSchema;
